import moment from 'moment';

import ProjectTypeIcon from '../../generic/ProjectTypeIcon';
import { TooltipButton } from '../../../generic/Button';
import Icon, { icons } from '../../../generic/Icon';
import Tooltip from '../../../generic/Tooltip';
import utils from '../../../../utils';
import { RouterLink } from '../../../generic/Link';
import type { Project } from '../../../../types';
import { isProjectValidForRelease } from '../helper';

const COLUMN_TEXT_MAX_LENGTH = 30;

const ProjectLink = ({ children, project, style }) =>
  <RouterLink
    to={`/projects/${utils.nuc(project.locator)}`}
    className="project-table__row__link"
    style={style}
  >
    {children}
  </RouterLink>;

type ProjectRowProps = {
  onSelect: (project: Project) => void;
  project: Project;
};

const ProjectListRow = (props: ProjectRowProps) => {
  const { project: row } = props;
  const latest = row.revisions?.[0];
  const onClick = () => props.onSelect(props.project);

  // check if this project is a valid candidate to be added to a release
  const isValidProject = isProjectValidForRelease(row);
  const isInvalidProject = !isValidProject;

  // prepare a tooltip message to indicate why the project isn't valid
  const tooltip = 'Projects without analyzed revisions cannot be added to a group';

  return (
    <tr className={isInvalidProject ? 'disable-add-project' : undefined}>
      <td className="plus-column">
        <TooltipButton
          type="outline"
          size="icon"
          id={`tooltip-add-project-${row.locator}`}
          icon={icons.plusCircle}
          tooltip={tooltip}
          showTooltip={isInvalidProject}
          isDisabled={isInvalidProject}
          onClick={onClick}
        />
      </td>
      <ProjectLink key={`title-${row.locator}`} style={{ width: '30%' }} project={row}>
        {!!row.title && (
          <Tooltip
            id={`tooltip-project-title-${row.locator}`}
            showTooltip={(row.title?.length ?? 0) > COLUMN_TEXT_MAX_LENGTH}
            tooltip={row.title}
          >
            <b className="project-title">{utils.trimString(row.title, COLUMN_TEXT_MAX_LENGTH)}</b>
          </Tooltip>
        )}
        {!row.public && (
          <Tooltip
            id={`tooltip-project-private-${row.locator}`}
            tooltip="Private"
          >
            <span className="project-table__row__icon">
              <Icon icon={icons.lock} />
            </span>
          </Tooltip>
        )}
        <ProjectTypeIcon project={row} />
      </ProjectLink>
      <ProjectLink key={`stats-${row.locator}`} style={{ width: '28%' }} project={row}>
        {latest && (
          <span className="project-stats-badge">
            <span style={{ display: 'inline-block' }}><Icon icon={icons.pieChart} /> &nbsp; <b>{latest.dependency_count}</b> deps &nbsp;&bull;&nbsp; <b>{latest.license_count}</b> licenses</span>
          </span>
        )}
      </ProjectLink>
      <ProjectLink key={`updated-${row.locator}`} style={{ width: '23%' }} project={row}>
        <span className="project-modified" style={{ opacity: 0.9, fontSize: '15px' }}>{moment(row.updatedAt).fromNow()}</span>
      </ProjectLink>
    </tr>
  );
};

export default ProjectListRow;
